module.exports = __webpack_public_path__ + "img/words_icon.47aa4641.png";